module.exports = __webpack_public_path__ + "static/media/cleverchords_1.3c528f4a.jpg";